export default __webpack_public_path__ + "static/media/banner3.73a2e789.jpg";